import no from '~/i18n/no.json'
import en from '~/i18n/en.json'
import {useLocaleStore} from '~/stores/locale';
export default defineI18nConfig(() => {

    const localeStore = useLocaleStore()

    return {
        legacy: false,
        locale: localeStore.locale || 'no',
        messages: {
            en,
            no
        }
    };
})
